export class FsSums {
  balance: number; // all with manual entries
  sumITP: number; // without manual entries
  sumITPrevYear: number; // without manual entries
  sumITYearBeforePrev: number; // without manual entries
  manualDebit: number;
  manualCredit: number;
  quarterlySums: Map<string, number>;
  yearlySums: Map<string, number>;
  dateColumnSums: Map<string, number>;

  constructor() {
    this.resetAllSums();
  }

  resetAllSums(): void {
    this.balance = 0;
    this.sumITP = 0;
    this.sumITPrevYear = 0;
    this.sumITYearBeforePrev = 0;
    this.manualDebit = 0;
    this.manualCredit = 0;
    this.quarterlySums = new Map<string, number>();
    this.yearlySums = new Map<string, number>();
  }

  setDateColumnSumsKeys(selectedBSDateColumns: string[]): void {
    this.dateColumnSums = new Map(Array.from(selectedBSDateColumns.values()).map((date) => [date, 0]));
  }

  calculateYearlySums(): void {
    this.quarterlySums.forEach((quarterlySum, quarter) => {
      const year = quarter.slice(3);
      const currentYearSum = this.yearlySums.get(year) || 0;
      const newYearSum = currentYearSum + quarterlySum;
      this.yearlySums.set(year, newYearSum);
    });
  }
}
